import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { formatUrl } from '../core'
import Icon from './Icon'

const NavigationSubCategoryList = ({ subSection, isCurrentPage }) => {
  return (
    <ul>
      {subSection.map(item => (
        <NavigationSubCategoryListItem
          item={item}
          key={item.title}
          isCurrentPage={isCurrentPage}
        />
      ))}
    </ul>
  )
}

const NavigationSubCategoryListItem = ({ item, isCurrentPage }) => {
  return (
    <li className={isCurrentPage(item.slug) ? 'text-secondary' : ''}>
      <Link
        to={item.slug}
        className="flex items-center justify-between px-4 py-3 border-b border-secondary-lightest text-md"
      >
        <span>{item.title}</span>
        {isCurrentPage(item.slug) ? (
          <Icon icon="forwardArrow" className="w-3 h-2 fill-current" />
        ) : null}
      </Link>
    </li>
  )
}

const NavigationCategoryList = ({
  categories,
  isCurrentPage,
  inCategoryPage,
  openCategoryNav,
}) => {
  return (
    <ul>
      {categories
        .filter(
          item =>
            item.category !== 'Coronavirus' &&
            item.category !== 'Morrisons Alexa Skill'
        )
        .map(item => {
          let openCategoryList = openCategoryNav(item.category)
          return (
            <li key={item.category}>
              <Link
                to={`/${formatUrl(item.category)}/`}
                className={`py-3 block border-b border-secondary-lightest cursor-pointer font-medium text-lg
              ${openCategoryList ? 'text-secondary' : ''}`}
              >
                {item.category}
              </Link>
              {openCategoryList && !inCategoryPage && (
                <NavigationSubCategoryList
                  subSection={item.categoryData}
                  isCurrentPage={isCurrentPage}
                />
              )}
            </li>
          )
        })}
    </ul>
  )
}

NavigationCategoryList.propTypes = {
  categories: PropTypes.array,
  isCurrentPage: PropTypes.func,
  openCategoryNav: PropTypes.func,
}

NavigationCategoryList.defaultProps = {
  categories: [],
}

export default NavigationCategoryList
